import React, { useState } from 'react';

import lang from '../../../../../../../lib/language';
import { NullableString } from '../../../../../../../lib/util/types';

import EditIcon from '../../../../../../../assets/img/username_edit.png';
import { useIsMobile } from '../../../../../../../hooks';
import { BaseModal, ChangeUsernameModal, ClickableImage, MobileDrawer, UserPhoto } from '../../../../../../index';

import styles from './PersonalNameDetails.module.scss';

type Props = {
    firstName: string;
    middleName: string;
    lastName: string;
    username: NullableString;
}

const PersonalNameDetails = ({ firstName, middleName, lastName, username }: Props) => {
  let nameDetails: object = {};
  const isMobile = useIsMobile();

  const [isChangeUsernameModalOpened, setIsChangeUsernameModalOpened] = useState(false);

  if (middleName) {
    nameDetails = {
      [lang.commonOnboardingPersonalDetailsFirstName()]: firstName,
      [lang.commonMiddleName()]: middleName,
      [lang.commonOnboardingPersonalDetailsLastName()]: lastName,
      [lang.userNameTitle()]: username,
    };
  } else {
    nameDetails = {
      [lang.commonOnboardingPersonalDetailsFirstName()]: firstName,
      [lang.commonOnboardingPersonalDetailsLastName()]: lastName,
      [lang.userNameTitle()]: username,
    };
  }

  return (
    <div className={styles.wrapperNameDetails}>
      {isMobile && (
        <div className={styles.detailsHeader}>
          <div>{lang.commonNames()}</div>
        </div>
      )}
      <div className={styles.containerDetails}>
        <div className={styles.cardDetails}>
          {!isMobile && (
            <div className={styles.photo}>
              <UserPhoto first_name={firstName} last_name={lastName} isHeader fullSize />
            </div>
          )}
          {
            Object.entries(nameDetails).map(([key, value]) => (
              <div className={styles.cardContent} key={key}>
                <span className={styles.cardKey}>{key}</span>
                <span className={styles.nameDetailsCardValue}>
                  <div className={styles.valueWrapper}>
                    {key === lang.userNameTitle() && (
                      <div className={styles.edit}>
                        <ClickableImage
                          className={styles.editButton}
                          src={EditIcon}
                          alt="Edit Username"
                          onClick={() => setIsChangeUsernameModalOpened(true)}
                        />
                      </div>
                    )}
                    {value}
                  </div>
                </span>
              </div>
            ))
          }
        </div>
      </div>
      {isMobile && <div className={styles.mobileMargin} />}
      {isMobile ? (
        <MobileDrawer
          isOpen={isChangeUsernameModalOpened}
          title={lang.userNameEdit()}
          onClose={() => setIsChangeUsernameModalOpened(false)}
        >
          <ChangeUsernameModal
            username={username}
            onClose={() => setIsChangeUsernameModalOpened(false)}
          />
        </MobileDrawer>
      ) : (
        <BaseModal isOpen={isChangeUsernameModalOpened}>
          <ChangeUsernameModal
            username={username}
            onClose={() => setIsChangeUsernameModalOpened(false)}
          />
        </BaseModal>
      )}
    </div>
  );
};

export default PersonalNameDetails;
